export const ChatMock = () => {
  return (
    <svg
      width="246"
      height="177"
      viewBox="0 0 246 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.73938"
        y="1.32715"
        width="244.521"
        height="174.858"
        rx="10.7527"
        fill="#FFFDF9"
      />
      <rect
        x="0.73938"
        y="1.32715"
        width="244.521"
        height="174.858"
        rx="10.7527"
        stroke="#D7D3C9"
      />
      <rect
        x="14.4993"
        y="130.939"
        width="214.937"
        height="28.8849"
        rx="14.4424"
        fill="#F5F3EB"
      />
      <path
        d="M220.354 145.033L202.994 136.812L204.242 143.891L209.145 146.197V144.504L205.614 142.842L205.016 139.463L216.776 145.033L205.016 150.603L205.775 146.305L204.334 145.63L202.994 153.253L220.354 145.033Z"
        fill="#D7D3C9"
      />
      <circle
        cx="34.3873"
        cy="38.7062"
        r="18.7544"
        fill="#D7D3C9"
        stroke="#FFFDF9"
        strokeWidth="1.71609"
      />
      <circle
        cx="213.349"
        cy="90.9523"
        r="18.7544"
        fill="#F5F3EB"
        stroke="#FFFDF9"
        strokeWidth="1.71609"
      />
      <path
        d="M32.6882 42.1067H27.5908V31.912H41.1837V42.1067H36.5366L32.2634 47.204H34.4807L37.3352 43.8058H42.8828V30.2129H25.8917V43.8058H32.6882V42.1067Z"
        fill="#FFFDF9"
      />
      <path
        d="M213.349 90.9545C215.694 90.9545 217.597 89.0515 217.597 86.7068C217.597 84.362 215.694 82.459 213.349 82.459C211.004 82.459 209.101 84.362 209.101 86.7068C209.101 89.0515 211.004 90.9545 213.349 90.9545ZM213.349 84.1581C214.751 84.1581 215.898 85.305 215.898 86.7068C215.898 88.1085 214.751 89.2554 213.349 89.2554C211.947 89.2554 210.8 88.1085 210.8 86.7068C210.8 85.305 211.947 84.1581 213.349 84.1581Z"
        fill="#D7D3C9"
      />
      <path
        d="M219.041 92.6536H207.657L205.185 99.4501H217.894L217.274 97.751H207.606L208.846 94.3527H217.852L219.704 99.4501H221.513L219.041 92.6536Z"
        fill="#D7D3C9"
      />
      <rect
        x="60.1342"
        y="22.7725"
        width="150.771"
        height="31.8703"
        rx="4.90312"
        fill="#ECE9DF"
      />
      <rect
        x="69.9464"
        y="35.0293"
        width="106.643"
        height="7.35469"
        rx="3.67734"
        fill="#D7D3C9"
      />
      <rect
        x="38.078"
        y="75.0176"
        width="150.771"
        height="31.8703"
        rx="4.90312"
        fill="#F5F3EB"
      />
      <rect
        x="72.3979"
        y="87.2764"
        width="106.643"
        height="7.35469"
        rx="3.67734"
        fill="#ECE9DF"
      />
    </svg>
  );
};
